import type { CmsApiDocument } from '#/modules/cms/api/types/CmsApiDocument';
import { isDefined } from '#/utils/functional/type';

type Props = {
  content: CmsApiDocument;
};

export function getContentWithBanner({ content }: Props) {
  return isDefined(content.heroSearch);
}
